import { Box, Typography } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';
import { FIGURE, LEVEL_TONE } from '../utils/constants';
import { fmtHours } from '../utils/hours';
import MiniFigure from './MiniFigure';
import LoadBar from './LoadBar';

/** The top of a person's drawer: allocated / capacity / free (or excess), their load bar, and what is not counted. */
export default function PersonSummary({ row }) {
  const excess = row.allocated - row.capacity;

  return (
    <>
      <Box display="grid" gridTemplateColumns="repeat(3, minmax(0, 1fr))" gap={1.25} sx={{ mt: 2.5 }}>
        <MiniFigure label="Allocated" value={fmtHours(row.allocated)} />
        <MiniFigure label="Capacity" value={fmtHours(row.capacity)} />
        {excess > 0 ? <MiniFigure label="Excess" value={`+${fmtHours(excess)}`} alarm /> : <MiniFigure label="Free" value={fmtHours(-excess)} />}
      </Box>

      <Box sx={{ mt: 2.5 }}>
        <Box display="flex" alignItems="baseline" justifyContent="space-between">
          <Typography sx={{ fontSize: 13, fontWeight: 600, color: WD.ink }}>Load vs capacity</Typography>
          <Typography sx={{ fontSize: 13, fontWeight: 700, ...FIGURE, color: row.level === 'overloaded' ? LEVEL_TONE.overloaded.text : WD.ink }}>
            {row.capacity ? `${Math.round(row.pct)}%` : '-'}
          </Typography>
        </Box>
        <Box sx={{ mt: 1 }}>
          <LoadBar pct={row.pct} level={row.level} height={9} />
        </Box>
      </Box>

      {(row.paused > 0 || row.unscheduled > 0 || row.needsHours > 0) && (
        <Box component="ul" sx={{ mt: 2, mb: 0, pl: 2.5, fontSize: 12, color: WD.inkMuted, '& li': { mb: 0.25 } }}>
          {row.needsHours > 0 && (
            <li style={{ color: LEVEL_TONE.atCapacity.text }}>
              {row.needsHours} task{row.needsHours === 1 ? '' : 's'} in these dates {row.needsHours === 1 ? 'has' : 'have'} no hours set yet.
            </li>
          )}
          {row.paused > 0 && <li>Paused: {fmtHours(row.paused)} on hold, not counted until resumed.</li>}
          {row.unscheduled > 0 && <li>Unscheduled: {fmtHours(row.unscheduled)} on tasks with no due date.</li>}
        </Box>
      )}
    </>
  );
}
